import styled from 'styled-components';

export const FourItemsContainer = styled.section`
  position: relative;
  z-index: 5;

  display: flex;
  align-items: stretch;
  justify-content: center;

  width: calc(100% - var(--space-xxxxl));

  margin: calc(var(--space-xxxl) * -1) auto 0 auto;

  overflow: hidden;

  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(249, 250, 251, 0.96) 100%
  );

  border: 1px solid rgba(15, 23, 42, 0.06);

  border-radius: 24px;

  box-shadow:
    0 24px 60px rgba(15, 23, 42, 0.1),
    0 8px 24px rgba(15, 23, 42, 0.05);

  /* backdrop-filter: blur(12px); */

  @media screen and (max-width: 900px) {
    flex-wrap: wrap;

    width: calc(100% - var(--space-xxl));

    margin-top: calc(var(--space-xxl) * -1);

    border-radius: 20px;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;

    width: calc(100% - var(--space-l));

    margin-top: calc(var(--space-xl) * -1);

    border-radius: 18px;
  }
`;

export const FourItem = styled.div`
  flex: 1;

  display: flex;
  align-items: flex-start;

  gap: var(--space-m);

  padding: var(--space-xl);

  position: relative;

  background: transparent;

  &:not(:last-child)::after {
    content: '';

    position: absolute;

    top: 18%;
    right: 0;

    width: 1px;
    height: 64%;

    background: linear-gradient(
      180deg,
      transparent 0%,
      rgba(15, 23, 42, 0.08) 20%,
      rgba(15, 23, 42, 0.08) 80%,
      transparent 100%
    );
  }

  svg {
    flex-shrink: 0;

    margin-top: 0.2rem;

    font-size: 1.6rem;

    color: var(--orange4);

    filter: drop-shadow(0 4px 10px rgba(230, 139, 7, 0.18));
  }

  div {
    display: flex;
    flex-direction: column;
    gap: var(--space-xxs);
  }

  h4 {
    margin: 0;

    color: var(--grey7);

    font-size: 1rem;
    line-height: 1.3;
    font-weight: 850;

    letter-spacing: -0.01em;
  }

  p {
    margin: 0;

    color: var(--grey4);

    font-size: 0.9rem;
    line-height: 1.65;
    font-weight: 500;
  }

  @media screen and (max-width: 1100px) {
    padding: var(--space-l);

    h4 {
      font-size: 0.95rem;
    }

    p {
      font-size: 0.85rem;
    }
  }

  @media screen and (max-width: 900px) {
    width: 50%;

    &:nth-child(2)::after {
      display: none;
    }

    &:nth-child(-n + 2) {
      border-bottom: 1px solid rgba(15, 23, 42, 0.06);
    }
  }

  @media screen and (max-width: 600px) {
    width: 100%;

    padding: var(--space-m);

    align-items: flex-start;

    &:not(:last-child) {
      border-bottom: 1px solid rgba(15, 23, 42, 0.06);
    }

    &:not(:last-child)::after {
      display: none;
    }

    &:nth-child(-n + 2) {
      border-bottom: 1px solid rgba(15, 23, 42, 0.06);
    }

    svg {
      font-size: 1.35rem;
    }
  }
`;
